"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreDataSecurityApplicationsIdMapSlice = void 0;
const xuder_1 = require("@sonar-software/xuder");
const state_1 = require("./state.js");
const _types_1 = require("../../../../@types/index.js");
const empty = {
    activityPeriod: 0,
    integrationUser: '',
    monitors: [],
    name: '',
    status: _types_1.DataSecurityApplicationStatus.Added
};
function rebuildReferenceEntry(entry, existingEntry) {
    return Object.assign(Object.assign({}, existingEntry), entry);
}
exports.coreDataSecurityApplicationsIdMapSlice = (0, xuder_1.createUpdateSyncSlice)({
    name: 'CoreSonarObjectsIdMap',
    state: state_1.defaultApplicationsIdMapState,
    transform: (action, state = {}) => {
        var _a;
        if (!action.length) {
            return state;
        }
        const updatedState = Object.assign({}, state);
        for (const entry of action) {
            const key = entry.applicationId;
            updatedState[key] = rebuildReferenceEntry(entry, (_a = state[key]) !== null && _a !== void 0 ? _a : Object.assign({}, empty));
        }
        return updatedState;
    }
});
//# sourceMappingURL=update.js.map